import React from 'react';

const SerenifyLogo = () => {
  return (
    <header className="serenify-wordmark" aria-label="Serenify brand">
      Serenify
    </header>
  );
};

export default SerenifyLogo;
